import { EcommerceStrategyIcon } from '@/svgs'
import React from 'react'

function FiFromStrategy() {
   return (
      <section id="development-guide-section" className="section_secondary_bg">
         <div className="container">
            <h2 className="section_heading_title mb-3">
               From Concept to Conversion:
               <br />
               Our eCommerce Software Development Process
            </h2>

            <p className="section_desc">
               With 12+ years of expertise in eCommerce software development, we
               create secure, scalable, and high-performance solutions. Our
               structured approach enhances shopping experiences, optimizes
               backend operations, and maximizes sales potential.
            </p>

            <EcommerceStrategyIcon />
         </div>
      </section>
   )
}

export default FiFromStrategy
